var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.2339C20 15.9395 16.0287 20 10.1639 20C4.54098 20 0 15.5323 0 10C0 4.46774 4.54098 0 10.1639 0C12.9016 0 15.2049 0.987903 16.9795 2.61694L14.2131 5.23387C10.5943 1.79839 3.86475 4.37903 3.86475 10C3.86475 13.4879 6.69672 16.3145 10.1639 16.3145C14.1885 16.3145 15.6967 13.4758 15.9344 12.004H10.1639V8.56452H19.8402C19.9344 9.07661 20 9.56855 20 10.2339Z",
    fill: "url(#paint0_linear_528_129)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_528_129",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#058DD3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4c3735be9842fc83840507353851700e.svg";
export { ForwardRef as ReactComponent };